<crops-layout [cropTypes]="cropTypes"
></crops-layout>